import React, { useEffect } from "react";
import { Outlet, useMatches } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import SideBar from "../SideBar";
import { fetchHandbooks } from "../../../store/actions/handbookActions";
import {
  USER_ROLE_ADMIN,
  USER_ROLE_MANAGER,
} from "../../../utils/constants/userRoles";
import useWindowSize from "../../../hooks/useWindowSize";
import classes from "./Layout.module.scss";
import MobilePanel from "../MobilePanel";
import ModalCall from "../../blocks/modals/ModalCall";

export default function Layout() {
  const matches = useMatches();
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const { role_id } = useAppSelector((state) => state.auth.user);
  const { privateUrl }: any = matches?.slice(-1)?.pop()?.handle || {};
  const isManagement =
    role_id === USER_ROLE_ADMIN || role_id === USER_ROLE_MANAGER;
  const windowSize = useWindowSize();

  useEffect(() => {
    if (isAuthenticated) {
      if (isManagement) {
        dispatch(fetchHandbooks());
      }
    }
  }, [dispatch, isAuthenticated, isManagement]);

  const routeComponent = privateUrl ? (
    <PrivateRoute isAuthenticated={isAuthenticated}>
      <Outlet />
    </PrivateRoute>
  ) : (
    <Outlet />
  );

  return (
    <div className={classes.wrapper}>
      {windowSize.width >= 1200 && (
        <div className={classes.sidebar}>
          <SideBar />
        </div>
      )}
      {windowSize.width < 1200 && (
        <MobilePanel className={classes.mobile_panel} />
      )}
      <div className={classes.main}>{routeComponent}</div>
      {/* <ModalCall/>*/}
    </div>
  );
}
